import React from 'react';
import { LockIcon } from 'lucide-react';
import { trackCheckoutStart } from '../lib/metaPixel';
import { PRICE } from '../data/content';
import { SecurePaymentNote } from './SecurePaymentNote';

/** The single checkout the offer button leads to. Change here to update the whole page. */
export const CHECKOUT_URL = 'https://pmu-instructor-ready.impultienda.ar/checkout';
export const CURRENCY_NOTE = 'Secure payment · Processed in your local currency';

/** Anchor of the offer block — the only button that opens the checkout. */
export const OFFER_ANCHOR = '#offer-cta';
interface CtaButtonProps {
  label: string;
  /** 'checkout' opens the checkout; 'offer' scrolls to the offer block. */
  action?: 'checkout' | 'offer';
  className?: string;
}
export function CtaButton({
  label,
  action = 'offer',
  className = ''
}: CtaButtonProps) {
  const isCheckout = action === 'checkout';
  return <a href={isCheckout ? CHECKOUT_URL : OFFER_ANCHOR} onClick={isCheckout ? trackCheckoutStart : undefined} className={`group inline-flex items-center justify-center gap-2.5 text-center leading-tight sm:whitespace-nowrap rounded-[14px] bg-brand-cta px-6 py-[18px] font-body text-[14px] font-bold uppercase tracking-[0.04em] text-brand-cta-text shadow-[0_5px_0_0_#1E5236,0_18px_34px_-14px_rgba(30,82,54,0.7)] transition-[background-color,transform,box-shadow] duration-150 ease-out hover:bg-brand-cta-dark active:translate-y-[3px] active:shadow-[0_2px_0_0_#1E5236] focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-cta focus-visible:ring-offset-2 focus-visible:ring-offset-brand-ivory sm:px-8 sm:text-[15px] sm:tracking-[0.06em] ${className}`} data-id="element-1" data-mp="159q5kgbd2z6y">
      <span data-id="element-2" data-mp="6i15us02p3e5">{label}</span>
      <span aria-hidden="true" className="text-base font-normal transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-3" data-mp="6ikbb98jdzba">
        →
      </span>
    </a>;
}
interface CtaBlockProps {
  label: string;
  /** The offer block: shows the price and is the only one that opens the checkout. */
  showPrice?: boolean;
  className?: string;
}
export function CtaBlock({
  label,
  showPrice = false,
  className = ''
}: CtaBlockProps) {
  return <div id={showPrice ? 'offer-cta' : undefined} className={`flex scroll-mt-24 flex-col items-center text-center ${className}`} data-id="element-4" data-mp="3hwjda2c8zxbw">
      {showPrice ? <>
          <p className="font-body text-[3rem] font-bold leading-none tracking-[-0.01em] text-brand-charcoal" data-id="element-5" data-mp="3rugz6j6mxi1c">
            {PRICE}
          </p>
          <p className="mt-2 font-body text-[13px] font-semibold text-brand-charcoal/65" data-id="element-6" data-mp="4jzi94lrfybj">
            One-time payment — no subscription.
          </p>
        </> : <p className="flex items-center gap-1.5 font-body text-[11px] font-semibold uppercase tracking-[0.14em] text-brand-charcoal/60" data-id="element-7" data-mp="ehnoaqotgs90">
          <LockIcon className="h-3 w-3" strokeWidth={2} aria-hidden="true" data-id="element-8" data-mp="2l94y08iby6fg" />
          {CURRENCY_NOTE}
        </p>}
      <CtaButton label={label} action={showPrice ? 'checkout' : 'offer'} className="mt-4 w-full sm:w-auto sm:min-w-[420px]" data-id="element-9" data-mp="2galai3o38mkz" />
      {showPrice && <>
          <p className="mt-4 font-body text-[12px] text-brand-charcoal/60" data-id="element-10" data-mp="10orile539r0l">
            Digital product • No physical shipping • One-time purchase
          </p>
          <SecurePaymentNote className="mt-4" data-id="element-11" data-mp="qzzq94w494p5" />
        </>}
    </div>;
}